import React, { Component } from "react";
import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import CancelLoan from "../../../modals/CancelLoan/CancelLoan";
import ReplanLoan from "../../../modals/ReplanLoan/ReplanLoan";
import "./InfoCard.scss";
import { getSecureItem } from "../../../../utilsFunctions";
import { Button, Menu, MenuItem } from "@mui/material";
import axios from "axios";
import { BaseUrl, ImageBaseUrl } from "../../../../Environment";
import PreCloseLoan from "../../../modals/PreCloseLoan/PreCloseLoan";

class InfoCard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      mandateMenuAnchor: null,
      isCancelLoanPopupActive: false,
      isReplanLoanPopupActive: false,
      isPreCloseLoanPopupActive: false,
      headerData: '',
      loanOverView: '',
      amountOverView: '',
      loanId: '',
      loanCollectionId: '',
      loanData:{},
      isLoanActive: true,
      isInstallmentCalculator: false,
      customerInfo: {},
      isMandateLoading: false, 
    };
  }

  handleMandateMenuOpen = (event) => {
    this.setState({ mandateMenuAnchor: event.currentTarget });
  };

  handleMandateMenuClose = () => {
    this.setState({ mandateMenuAnchor: null });
  };

  componentWillReceiveProps = nextProps => {
    let headerData, loanOverView, amountOverView, loanId, loanCollectionId, isLoanActive, isInstallmentCalculator
    headerData = nextProps.infoCard.headerData
    loanOverView = nextProps.infoCard.loanOverView
    amountOverView = nextProps.infoCard.amountOverView

    isInstallmentCalculator = nextProps.infoCard.loanOverView.method === 'EMI Method'
    loanId = nextProps.infoCard.loanId
    loanCollectionId = nextProps.infoCard.loanCollectionId
    isLoanActive = nextProps.isLoanActive
    this.setState({
      headerData, loanOverView, amountOverView, loanId, loanCollectionId, isLoanActive, isInstallmentCalculator, customerInfo: nextProps.customerInfo?.personalDetails,loanData:nextProps.infoCard
    });
  }

  toggleReplanPopup = () => {
    let { isReplanLoanPopupActive } = this.state

    isReplanLoanPopupActive = !isReplanLoanPopupActive
    this.setState({ isReplanLoanPopupActive });
  }

  togglePreClosePopup = () => {
    let { isPreCloseLoanPopupActive } = this.state

    isPreCloseLoanPopupActive = !isPreCloseLoanPopupActive
    this.setState({ isPreCloseLoanPopupActive });
  }


  toggleCancelPopup = (value) => {
    let { isCancelLoanPopupActive, loanId } = this.state
    const { getCustomerDetailsById } = this.props

    isCancelLoanPopupActive = !isCancelLoanPopupActive
    this.setState({ isCancelLoanPopupActive });
    console.log('aransae ', value)
    if (value === 'confirm') {
      console.log('api call with loan id initilzed', loanId)
      getCustomerDetailsById(loanId)
    }

  }

  notDone = () => {
    alert("Oops! sorry, this features is under construction")
  }

  setupMandate = async (type = "upi") => {
    try {
      const {customerInfo, loanOverView, amountOverView, loanId} = this.state;
      const {name, email, phoneNo} = customerInfo;

      // Check if email is available before proceeding
      if (!email) {
        alert("Borrower email not found. Please ensure the borrower's email is added to set up Auto-Pay.");
        return;
      }

      this.setState({ isMandateLoading: true });

      // ----- Fetch Access Token -----
      const authToken = getSecureItem("token");
      const companyId = getSecureItem("loggedinUserCompany");
      const { data } = await axios.get(`${BaseUrl}/company/getCompanyProfile`, {
        params: { companyId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      // Check if Digital Payments is configured
      if (!data?.accessToken) {
        alert("Please ask your company to set up Digital Payments to use this feature, or contact support for assistance.");
        return;
      }

      const payload = {
        accessToken: data.accessToken,
        name,
        email,
        contact: phoneNo,
        amount: 100,
        description: `Setup of Auto-Pay for the Loan-ID: ${loanId}`,
        max_amount: Number(amountOverView?.balanceData+"00"),
        frequency: loanOverView?.collectionSequence,
        method: type,
        notes: {
          type: "Setup",
          loanId: loanId,
          mandateType: type == 'upi' ? 'UPI' : 'Netbanking',
        }
      };

      const response = await axios.post(`${ImageBaseUrl}api/razorpayMandate/payment/create-registration-link`, payload);

      if (response.data?.success) {
        const message = `Please click on the following link to set up Auto-Pay for your loan: ${response.data?.data?.short_url}`;
        window.open(
          `https://wa.me/${phoneNo?.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    } catch (error) {
      if(error?.response?.data?.message == "The Merchant is not activated"){
        alert("Your Razorpay account has not been activated yet. Please contact LendStack Support or the Razorpay team to get your account activated.");
      } else {
        alert("Failed to setup mandate. Please try again.");
      }
      console.log({error});
    }  finally {
      this.setState({ isMandateLoading: false });
    }
  };

  render() {

    const { isCancelLoanPopupActive, customerInfo, isReplanLoanPopupActive, isPreCloseLoanPopupActive, headerData, loanOverView, amountOverView, loanId, loanCollectionId, isLoanActive, isInstallmentCalculator, isMandateLoading, mandateMenuAnchor, loanData } = this.state
    const { action } = this.props

    return (
      <div className="infoCardComponent">
        {/* toggleCancelPopup */}
        <CustomerInfoHeader
          headerData={headerData}
          isLoanActive={isLoanActive}
          isInstallmentCalculator={isInstallmentCalculator}
          cancelClickEvent={this.toggleCancelPopup}
          replanClickEvent={this.toggleReplanPopup}
          preCloseClickEvent={this.togglePreClosePopup}
          setupMandate={this.setupMandate}
          customerInfo={this.state?.customerInfo || {}}
          isMandateLoading={isMandateLoading} 
          loanId={loanId}
          mandateMenuAnchor={mandateMenuAnchor}
          onMandateMenuOpen={this.handleMandateMenuOpen}
          onMandateMenuClose={this.handleMandateMenuClose}
        />

        <CustomerLoanInfo loanOverView={loanOverView} isInstallmentCalculator={isInstallmentCalculator} />

        <LoanProgress amountOverView={amountOverView} />

        {/* {true && <CancelLoan />} */}
        <CancelLoan loanId={loanId} open={isCancelLoanPopupActive} cancel={this.toggleCancelPopup} action={action} />
        <ReplanLoan loanId={loanId} loanData={loanData} customerInfo={customerInfo} open={isReplanLoanPopupActive} replan={this.toggleReplanPopup} action={action} />
        <PreCloseLoan loanId={loanId} loanCollectionId={loanCollectionId} balanceAmt={amountOverView?.balanceData} open={isPreCloseLoanPopupActive} preclose={this.togglePreClosePopup} action={action} />
      </div>
    );
  }
}
export default InfoCard;


let CustomerLoanInfo = (props) => {

  const { duration, collectionSequence, collectorName, method, penalty } = props.loanOverView
  const { isInstallmentCalculator } = props


  return (
    <div className="infoCard">
      <div className="cardContent">
        <div className="infocardmainDiv" >
          <div className="cardDetail duration">
            <h4 className="h4heading Fonts">{duration}</h4>
            <p className="pHeading Fonts">Duration</p>
          </div>

          <div className="cardDetail Fonts">
            <h4 className="h4heading Fonts">{collectionSequence}</h4>
            <p className="pHeading Fonts">Collection seq</p>
          </div>

          <div className="cardDetail Fonts">
            <h4 className="h4heading Fonts">{collectorName}</h4>
            <p className="pHeading Fonts">Collection Agent</p>
          </div>

          <div className="cardDetail">
            <h4 className="h4heading Fonts">{method}</h4>
            <p className="pHeading Fonts">Method</p>
          </div>

          {!isInstallmentCalculator &&
            <div className="cardDetail">
              <h4 className="h4heading Fonts">{penalty}</h4>
              <p className="pHeading Fonts">Penalty</p>
            </div>}
        </div>
      </div>
    </div>
  )
}

let CustomerInfoHeader = (props) => {
  const companyId = getSecureItem("loggedinUserCompany");
  const { loanType, totalLoanAmount, loanAmount, location, time, moratoriumPeriods, rateOfInterest, mandateCustomerId, mandateTokenId } = props.headerData;
  const {
    replanClickEvent, cancelClickEvent, isLoanActive, isInstallmentCalculator,
    setupMandate, isMandateLoading, preCloseClickEvent,
    mandateMenuAnchor, onMandateMenuOpen, onMandateMenuClose  // NEW
  } = props;
  const currency = getSecureItem("country")?.symbol;
  let countryCurrencySymbol = currency;

  return (
    <div className="headerPart">
      <div style={{display: "flex", flexDirection: "row", alignItems: "center"}} className="headerLeft">
        <div className="headerPartOne">
          <div className="headerPartOneOne Fonts">
            {countryCurrencySymbol} {totalLoanAmount}
            {/* {isInstallmentCalculator && <span> at {rateOfInterest} %</span>} */}
          </div>
          <div className="headerPartOneTwo Fonts"> {loanType}</div>
        </div>

        {/* BUTTON — only onClick changed */}
        <Button
          className="Fonts"
          disabled={!isLoanActive || isMandateLoading || (mandateCustomerId && mandateTokenId)}
          onClick={(e) => {
            if (mandateCustomerId && mandateTokenId) return;
            onMandateMenuOpen(e);
          }}
          style={{
            border: "1px solid #4d66f0",
            padding: "6px 14px",
            color: "#4d66f0",
            fontSize: 12,
            fontWeight: 500,
            cursor: !isLoanActive || isMandateLoading || (mandateCustomerId && mandateTokenId) ? "not-allowed" : "pointer",
            borderRadius: 6,
            textTransform: "initial",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            minWidth: 140,
            opacity: !isLoanActive || isMandateLoading || (mandateCustomerId && mandateTokenId) ? 0.6 : 1,
            transition: "all 0.2s ease",
          }}
        >
          {isMandateLoading && (
            <span
              style={{
                width: 12,
                height: 12,
                border: "2px solid #4d66f0",
                borderTopColor: "transparent",
                borderRadius: "50%",
                animation: "spin 0.8s linear infinite",
              }}
            />
          )}
          {isMandateLoading
            ? "Generating link to share..."
            : mandateCustomerId && mandateTokenId
            ? "Auto-Pay Enabled"
            : "Setup Auto-Pay"}
        </Button>

        {/* MENU — add right after Button */}
        <Menu
          anchorEl={mandateMenuAnchor}
          open={Boolean(mandateMenuAnchor)}
          onClose={onMandateMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            style: {
              borderRadius: 8,
              minWidth: 180,
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            },
          }}
          // ADD THIS
          MenuListProps={{
            style: {
              display: "flex",
              flexDirection: "column",  // ← forces vertical stacking
              padding: "4px 0",
            }
          }}
        >
          <MenuItem
            onClick={() => setupMandate("upi")}
            style={{ fontSize: 13, gap: 8, width: "100%", paddingBlock: "10px" }}  // ADD width: "100%"
          >
            📱 UPI Mandate
          </MenuItem>
          <MenuItem
            onClick={() => setupMandate("emandate")}
            style={{ fontSize: 13, gap: 8, width: "100%", paddingBlock: "10px" }}  // ADD width: "100%"
          >
            🏦 Netbanking Mandate
          </MenuItem>
        </Menu>
      </div>

      <div className="headerRightSide">

        {
          isInstallmentCalculator &&

          <div className="headerPartTwo">
            <div className="headerPartTwoOne Fonts"> {moratoriumPeriods} months</div>
            <div className="headerPartTwoTwo Fonts">Moratorium </div>
          </div>
        }
        {isInstallmentCalculator && <div className="headerPartTwo">
          <div className="headerPartTwoOne Fonts"> {loanAmount}</div>
          <div className="headerPartTwoTwo Fonts">Value after Moratorium </div>
          </div>
        }

        <div className="headerPartTwo">
          <div className="headerPartTwoOne Fonts"> {location}</div>
          <div className="headerPartTwoTwo Fonts">Collection Loc.</div>
        </div>

        <div className="headerPartThree">
          <div className="headerPartThreeOne Fonts"> {time}</div>
          <div className="headerPartThreeTwo Fonts">Collection Time</div>
        </div>
        <div className="headerPartFour">
          <button
            onClick={preCloseClickEvent}
            disabled={!isLoanActive}
            className={isLoanActive ? 'cancelBtn' : 'cancelBtn disableLoanButton'}>
            PreClose
          </button>
        </div>
        <div className="headerPartFour">
          <button
            onClick={replanClickEvent}
            disabled={!isLoanActive}
            className={isLoanActive ? 'cancelBtn' : 'cancelBtn disableLoanButton'}>
            Replan
          </button>
        </div>
        <div className="headerPartFour">
          <button
            onClick={cancelClickEvent}
            disabled={!isLoanActive}
            className={isLoanActive ? 'cancelBtn' : 'cancelBtn disableLoanButton'} >
            Cancel
          </button>
        </div>
      </div>
    </div >
  )
}

let LoanProgress = (props) => {
  const { totalAmountPaid, balanceData, percentage, paidPenalty } = props.amountOverView
  const currency = getSecureItem("country")?.symbol;
  let countryCurrencySymbol = currency;
    console.log("currency symbol",countryCurrencySymbol )
  return (
    <div className="loanProgress">

      <div className="progress" >
        <div className="circularBar Fonts">
          <CircularProgressbarWithChildren
            counterClockwise={true}
            value={percentage}
            text={`${percentage}%`}
            styles={buildStyles({
              textColor: "black",
              pathColor: "#00D95E",
              trailColor: "rgb(177, 169, 169)",
              fontWeight: "bold",
            })}
          >
            <div style={{ fontSize: "9px", marginTop: "26px", color: "#a8a8a8" }} className="Fonts">
              Received
          </div>
          </CircularProgressbarWithChildren>
        </div>
        <div className="MainAmountDisplay">
          <div className="amountDisplay Fonts">

            {countryCurrencySymbol}&nbsp;&nbsp;{parseFloat(totalAmountPaid)}

            <div className="type Fonts">Total Amount Paid</div>
          </div>

          <div className="amountDisplay Fonts">
            {countryCurrencySymbol}&nbsp;&nbsp;{balanceData}
            <div className="type Fonts">Balance Amount</div>
          </div>
          <div className="amountDisplay Fonts">
            {countryCurrencySymbol}&nbsp;&nbsp;{paidPenalty}
            <div className="type Fonts">Penalty Applied</div>
          </div>
        </div>
      </div >
    </div >
  )
}


